import {DTStoreNode, StoreNodeOutputData} from 'common/src/modules/decisionTree/decisionTree.types';
import {LocationTargetingMethodValue} from 'common/src/modules/locationFeed/locationFeed.types';
import {OutputType} from 'common/src/modules/nodes/nodes.types';
import {toAiLocationTargetingMethod} from '../aiModels/cardDetailsAI.enums';
import {
  getBaseHeader,
  getDestinationPhrase,
  getOutputIdentifier,
  getOutputTypePhrase,
} from './utils';

function getLocationOutputWhenPhrase(output: StoreNodeOutputData): string {
  switch (output.type) {
    case OutputType.Regular:
    case OutputType.Last:
      return 'when store selected';
    case OutputType.Fallback:
    default:
      return 'when no store';
  }
}

export function locationCardToText(card: DTStoreNode, mode: 'short' | 'full'): string {
  const header = getBaseHeader(card);
  const locationMethodName = toAiLocationTargetingMethod(card.locationTargetingMethod) ?? '';

  if (mode === 'short') {
    const purpose = locationMethodName ? `Purpose: Select store by ${locationMethodName}` : '';

    const outputLines = card.outputs.map((output: StoreNodeOutputData) => {
      const outputId = getOutputIdentifier(output);
      const outputType = getOutputTypePhrase(output);
      const dest = getDestinationPhrase(output.nodeId);

      return `Output ${outputId} ${outputType} ${dest}`;
    });

    return [header, purpose, ...outputLines].filter(Boolean).join('\n');
  }

  const locationFeedLine = card.locationFeed
    ? `Location Feed '${card.locationFeed.name}' ID ${
        card.locationFeed.id != null ? card.locationFeed.id : 'not set'
      }`
    : 'Location Feed not set';
  const locationSetLine = card.locationSet
    ? `Location Set '${card.locationSet.name}' ID ${
        card.locationSet.id != null ? card.locationSet.id : 'not set'
      }`
    : 'Location Set not set';
  const isSpecificStore =
    card.locationTargetingMethod === LocationTargetingMethodValue.SpecificStore;
  const topLocationIdsLine =
    isSpecificStore && card.topLocationIds?.length
      ? `Specific Location Ids [${card.topLocationIds.map((id) => `'${id}'`).join(',')}]`
      : isSpecificStore
        ? 'Specific Location Ids not set'
        : null;

  const outputLines = card.outputs.map((output: StoreNodeOutputData) => {
    const outputId = getOutputIdentifier(output);
    const dest = getDestinationPhrase(output.nodeId);
    const whenPhrase = getLocationOutputWhenPhrase(output);
    const valuesPart = output.values?.length ? ` values=[${output.values.join(', ')}]` : '';

    return `Output ${outputId} ${dest} ${whenPhrase}${valuesPart}`;
  });

  return [header, locationFeedLine, locationSetLine, topLocationIdsLine, ...outputLines]
    .filter(Boolean)
    .join('\n');
}
